import { createClient } from "@supabase/supabase-js";

// Create React App only embeds env vars that start with REACT_APP_.
// NEXT_PUBLIC_* is for Next.js and is ignored by react-scripts unless you customize webpack.
function pickUrl() {
  return (
    process.env.REACT_APP_SUPABASE_URL ||
    process.env.NEXT_PUBLIC_SUPABASE_URL ||
    ""
  ).trim();
}

function pickKey() {
  return (
    process.env.REACT_APP_SUPABASE_ANON_KEY ||
    process.env.REACT_APP_SUPABASE_PUBLISHABLE_DEFAULT_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ||
    process.env.NEXT_PUBLIC_SUPABASE_PUBLISHABLE_DEFAULT_KEY ||
    ""
  ).trim();
}

const rawUrl = pickUrl();
const rawKey = pickKey();

/** True if .env still has template values or is missing. */
function isPlaceholderConfig(url, key) {
  if (!url || !key) return true;
  if (url.includes("YOUR_PROJECT_REF")) return true;
  if (key === "your_anon_key") return true;
  return false;
}

const configured = !isPlaceholderConfig(rawUrl, rawKey);

export const supabase = configured ? createClient(rawUrl, rawKey) : null;

export const isSupabaseConfigured = configured;

export function getPublicStorageUrl(pathInBucket) {
  if (!supabase || !pathInBucket) return null;
  const { data } = supabase.storage
    .from("site-images")
    .getPublicUrl(pathInBucket.replace(/^\//, ""));
  return data?.publicUrl ?? null;
}
